import { Action } from "@ngrx/store";

export const OPEN = '[Widget Gallery] Open';
export const CLOSE = '[Widget Gallery] CLOSE';

export class Open implements Action {
  readonly type = OPEN;
  constructor() { }
}

export class Close implements Action {
  readonly type = CLOSE;
  constructor() { }
}

export type Actions =
  Open |
  Close;
